var map = {
	"./Inter/Inter_18pt-Black.ttf": 4212,
	"./Inter/Inter_18pt-BlackItalic.ttf": 4116,
	"./Inter/Inter_18pt-Bold.ttf": 522,
	"./Inter/Inter_18pt-BoldItalic.ttf": 1126,
	"./Inter/Inter_18pt-ExtraBold.ttf": 4166,
	"./Inter/Inter_18pt-ExtraBoldItalic.ttf": 8738,
	"./Inter/Inter_18pt-ExtraLight.ttf": 861,
	"./Inter/Inter_18pt-ExtraLightItalic.ttf": 6265,
	"./Inter/Inter_18pt-Italic.ttf": 3651,
	"./Inter/Inter_18pt-Light.ttf": 8441,
	"./Inter/Inter_18pt-LightItalic.ttf": 8485,
	"./Inter/Inter_18pt-Medium.ttf": 4538,
	"./Inter/Inter_18pt-MediumItalic.ttf": 4854,
	"./Inter/Inter_18pt-Regular.ttf": 7017,
	"./Inter/Inter_18pt-SemiBold.ttf": 1980,
	"./Inter/Inter_18pt-SemiBoldItalic.ttf": 9804,
	"./Inter/Inter_18pt-Thin.ttf": 8022,
	"./Inter/Inter_18pt-ThinItalic.ttf": 3314,
	"./space_grotesk/SpaceGrotesk-Bold.woff2": 5823,
	"./space_grotesk/SpaceGrotesk-Light.woff2": 3130,
	"./space_grotesk/SpaceGrotesk-Medium.woff2": 5067,
	"./space_grotesk/SpaceGrotesk-Regular.woff2": 770,
	"./space_grotesk/SpaceGrotesk-SemiBold.woff2": 97,
	"./space_mono/SpaceMono-Bold.woff2": 8291,
	"./space_mono/SpaceMono-BoldItalic.woff2": 5383,
	"./space_mono/SpaceMono-Italic.woff2": 9922,
	"./space_mono/SpaceMono-Regular.woff2": 1094
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8056;